/* "Barrel" of Http Interceptors */
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AddHeaderInterceptor } from './AddHeaderinterceptor';
import { StaticJsonCacheBusterInterceptor } from './StaticJsonCacheBusterInterceptor';


/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AddHeaderInterceptor, multi: true },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: StaticJsonCacheBusterInterceptor,
    multi: true,
  },
];
